import RoadMapGeneric from "../components/Roadmaps/RoadMapGeneric";
import { roadIelts } from "../utils/roadIelts";

const RoadMapIelts = (props) => <RoadMapGeneric {...props} roadData={roadIelts} />;
export default RoadMapIelts;